// extracted by mini-css-extract-plugin
export var createdDate = "_kb-1";
export var divider = "_kb-2";
export var headerDivider = "_kb-3";
export var messagesCard = "_kb-0";
export var messagesContainer = "_kb-6";
export var messagesContainerWrapper = "_kb-4";
export var showLeftPanelButton = "_kb-8";
export var topButtons = "_kb-7";
export var withPadding = "_kb-5";